'use client';

import { useEffect, useState } from 'react';

import { MobileTabletFilters } from '@/components/Inventory/InventoryFilters/MobileTabletFilters';
import { mobileFiltersClass } from '@/constants/inventory';

export const ConditionalMobileFilters = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const hasMobileFilters = document.getElementsByClassName(mobileFiltersClass).length > 0;

    if (!hasMobileFilters) setShow(true);
  }, []);

  if (!show) return null;

  return <MobileTabletFilters />;
};
